"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoSchool = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NoSchool = require("./NoSchool.styles");
var _NoSchool2 = require("./NoSchool.labels");
var _hooks = require("../../hooks");
var _A = require("../../UI/A");
var _Button = require("../../UI/Button");
var _Modal = require("../../Layout/Modal");
var _urls = require("../../utilities/urls");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var NoSchool = function NoSchool(props) {
  var _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'popup' : _props$layout,
    _props$techSupportUrl = props.techSupportUrl,
    techSupportUrl = _props$techSupportUrl === void 0 ? _urls.supportUrl : _props$techSupportUrl,
    _props$logoutUrl = props.logoutUrl,
    logoutUrl = _props$logoutUrl === void 0 ? document.location.origin : _props$logoutUrl,
    onClose = props.onClose;
  var _useSessionData = (0, _hooks.useSessionData)(),
    isSessionDataReady = _useSessionData.isSessionDataReady,
    _useSessionData$first = _useSessionData.firstName,
    firstName = _useSessionData$first === void 0 ? '' : _useSessionData$first;
  var styles = (0, _NoSchool.useStyles)(props);
  var getLabel = (0, _hooks.useLabels)({
    labels: _NoSchool2.labels
  });
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isPopupOpen = _useState2[0],
    setIsPopupOpen = _useState2[1];
  var handleClose = function handleClose(event) {
    setIsPopupOpen(false);
    window.cet.accessmanagement.logout(logoutUrl);
    if (onClose) {
      onClose(event);
    }
  };
  if (!isSessionDataReady) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-NoSchool'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal, {
      layout: layout,
      isOpen: isPopupOpen,
      onClose: handleClose,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
        title: getLabel('hello_user_name').replace('{X}', firstName),
        subTitle: getLabel('good_to_have_you')
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Content, {
        children: [getLabel('message'), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: getLabel('now_what')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), getLabel('go_to'), /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
            to: techSupportUrl,
            target: "_blank",
            children: getLabel('tech_support')
          }), ".", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), getLabel('use_as_guest')]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer, {
        justifyContent: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            view: "outlined",
            color: "primary",
            onClick: handleClose,
            id: "ccNoSchoolButton",
            children: getLabel('confirm')
          })
        })
      })]
    })
  });
};
exports.NoSchool = NoSchool;